import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpClientJsonpModule } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SubscribeErrorComponent } from './modal/subscribe-error/subscribe-error.component';
import { SubscribeOkComponent } from './modal/subscribe-ok/subscribe-ok.component';

interface MailChimpResponse {
  result: string;
  msg: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private router: Router, private http: HttpClient, private modalService: NgbModal) {}

  query = '';
  emailAddress = '';
  datenschutzAccept = false;
  closeResult: string;

  submitted = false;
  error = '';



  searchKeyDownFunction(event) {
    if (event.keyCode === 13) {
      // console.log('you just clicked enter');
      // this.router.navigate(['/search'], { queryParams: { q: 'energy' } }); // does'nt work
      window.location.href = '/search?q=' + this.query; // does work
    }
  }


  openSubscribeOkModal() {
    this.modalService.open(SubscribeOkComponent).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openSubscribeErrorModal() {
    this.modalService.open(SubscribeErrorComponent).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  subscribe() {
    console.log('subscribe');
    const mailChimpEndpoint = 'https://startup.us18.list-manage.com/subscribe/post-json?u=ebe538fd35ce21a37e73bed5b&amp;id=350d6fe531&';

    const params = new HttpParams()
      // .set('NAME', this.nameControl.value)
      .set('EMAIL', this.emailAddress)
      .set('b_ebe538fd35ce21a37e73bed5b_350d6fe531', ''); // hidden input name

    const mailChimpUrl = mailChimpEndpoint + params.toString();

    return this.http.jsonp<MailChimpResponse>(mailChimpUrl, 'c').subscribe(response => {
      if (response.result && response.result !== 'error') {
        this.submitted = true;
      } else {
        this.error = response.msg;
      }
      this.emailAddress = '';
      this.openSubscribeOkModal();
    }, error => {
      console.error(error);
      this.error = 'Sorry, an error occurred.';
      this.openSubscribeErrorModal();
      this.emailAddress = '';
    });
  }

  subscribeNewsKeyDownFunction(event) {
    // console.log('key', event );
    if (event.keyCode === 13) {
      // this.subscribe();
    }
  }

}
